import React from 'react';
import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';

/**
 * Renders MUI Icon button to remove recipient.
 * @returns {React.FC}
 */

const RecipientItemActions = ({ deleteRecipientItem, StyledIconButton = IconButton, disabled }) => (
  <StyledIconButton size="small" onClick={deleteRecipientItem} disabled={disabled}>
    <Tooltip title="Delete recipient">
      <DeleteIcon />
    </Tooltip>
  </StyledIconButton>
);

export default RecipientItemActions;

RecipientItemActions.propTypes = {
  deleteRecipientItem: PropTypes.func.isRequired,
  StyledIconButton: PropTypes.elementType,
  disabled: PropTypes.bool
};
